import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ContactListsSliceState = {
  shouldRefreshList?: boolean;
};

const initialState: ContactListsSliceState = {
  shouldRefreshList: false,
};

export const contactListsSlice = createSlice({
  name: 'contactLists',
  initialState,
  reducers: {
    reset: () => initialState,
    setShouldRefreshList: (
      state: ContactListsSliceState,
      action: PayloadAction<boolean>
    ) => {
      state.shouldRefreshList = action.payload;
    },
  },
});

export const { setShouldRefreshList } = contactListsSlice.actions;

export default contactListsSlice;
